import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=5e8ef7a7&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e8ef7a7')) {
      api.createRecord('5e8ef7a7', component.options)
    } else {
      api.reload('5e8ef7a7', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=5e8ef7a7&", function () {
      api.rerender('5e8ef7a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/tabs/src/tabs.vue"
export default component.exports